import React, { useContext, useEffect, useState } from "react";
import { getAllGame } from "../../api/user";
import SmallLoader from "../../components/smallLoader";
import { GameContext } from "../../store/game/GameContext";
import Welcome from "./Welcome";
import Game from "./Game";
import { useOutletContext } from "react-router";

const FindGames = () => {
  const { fetching, setFetching } = useContext(GameContext);
  const { search } = useOutletContext(); // Access search from Outlet context
  const [games, setGames] = useState([]);

  const fetchGame = async (controller) => {
    try {
      setFetching(true);
      const response = await getAllGame({ signal: controller.signal });
      if (response?.status === 200) {
        setGames(response.data.data);

        if(response?.game_notification > 0){
          localStorage.setItem("notificationCount", response?.game_notification);
        }

      } else {
        console.log("Error occurred");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.log(error);
      }
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchGame(controller);

    return () => {
      localStorage.removeItem("game_type");
      localStorage.removeItem("isAuthenticated");
      controller.abort();
      console.log("Clean up: fetch aborted");
    };
  }, []);

  // Filter games based on search query
  const filteredGames = games.filter((game) =>
    (game.title && game.title.toLowerCase().includes(search.toLowerCase())) ||
    (game.description && game.description.toLowerCase().includes(search.toLowerCase()))
  );

  return (

    <div className={`${games.length === 0 ? "block" : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 lg:gap-x-16 gap-x-8 gap-y-7"} mt-5 md:mt-12 pl-8 pr-5 min-h-20`}>
      {fetching ? (
        <SmallLoader />
      ) : (
        <>
          {games.length === 0 && !search && <Welcome />}

          {games.length > 0 && filteredGames.length === 0 && (
            <p>No league found with that title or description.</p>
          )}

          {filteredGames.map((game) => (
            <Game key={game.id} game={game} />
          ))}
        </>
      )}
    </div>
  );
};

export default FindGames;
